export default function WinFormSelectValue({children, style = {}, id}) {

    return (
        <div id={id} style={{backgroundColor: '#f5f5f5', border: '1px solid #cfcfcf', width: 80, height: 20, paddingLeft: 2, ...style}}>
            {children}
        </div>
    )
}